export default __webpack_public_path__ + "static/media/gallery4.8736e694.jpg";